/**
 * Statistics Page JavaScript - N6 AI Trading Platform
 * Period button toggle (charts, sidebar, theme handled by dashboard.js)
 */
document.addEventListener('DOMContentLoaded', function() {
  var periodBtns = document.querySelectorAll('.stat-period-btn');
  periodBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      periodBtns.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });
});
